import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Scrollbar} from '../../components';

const CTSection = ({ children, className, isFullHeight, title, titleContent, width = 12}) => {
  const cssBEM = 'module';
  const classes = classnames(className, cssBEM, `col-${width}`,
    {
      [`${cssBEM}--fullHeight`]: isFullHeight
    }
  );

  return <div className={classes}>
    <section className="card">
      <div className="card-title">
        <h5>{ title }</h5>
        <div>{ titleContent }</div>
      </div>
      <div className="module__list">
        <Scrollbar>
          { children }
        </Scrollbar>
      </div>
    </section>
  </div>;
};

CTSection.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  isFullHeight: PropTypes.bool,
  title: PropTypes.any,
  titleContent: PropTypes.any,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

export default CTSection;
